// extracted by mini-css-extract-plugin
var _1 = "Pr77GL4LTPUSCeBmFS69";
var _2 = "G4kipUYb6hEL0Khqhriu";
var _3 = "_6WBu37myb7nGzNsm6leQ";
var _4 = "j1M7ypZljv9nrXLawvPz";
var _5 = "JOPfLiaSZSzmfRQr507p";
export { _1 as "button", _2 as "compact", _3 as "controls", _4 as "icon", _5 as "title" }
